import React from 'react';
import '../styles/FrameContainer.css'
const FrameContainer = ()=>{
    return(
        
        <div className='container-frame'>
    <div className={`corner top left frame-border thin t-l-radius`}></div>
    <div className={`corner top right frame-border thin t-r-radius`}></div>
    
    <div className={`corner bottom left frame-border thin b-l-radius`}></div>
    <div className={`corner bottom right frame-border thin b-r-radius`}></div>
    </div>
    
    )
}
export default FrameContainer;

